<template>
  <v-card style="min-height: 90vh">
    <v-toolbar color="#58595b" dense dark class="mb-0">
      Lead Add Multiple Grid
      <v-spacer></v-spacer>
      <v-btn
        small
        raised
        color="info"
        :loading="saving"
        @click="
          $emit('close');
          created = [];
        "
      >
        Close
      </v-btn>
    </v-toolbar>
    <v-card flat>
      <v-card-text>
        <v-form ref="leadsForm">
          <v-layout class="salesForm" key="form" wrap justify-center>
            <!-- Lead From Section -->
            <v-flex v-if="!keepSupplierData" class="mb-4" xs12>
              <v-card class="ma-2" elevation="5" style="height: 100%">
                <v-toolbar
                  color="#325181"
                  style="font-weight: bold"
                  dense
                  dark
                  class="mb-0"
                >
                  Lead From
                  <v-spacer></v-spacer>
                  <v-btn icon @click="showLocked = !showLocked">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                  <v-btn icon @click="keepSupplierData = !keepSupplierData">
                    <v-icon v-if="!keepSupplierData">mdi-arrow-down</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text v-if="showLocked">
                  <v-layout row wrap>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-autocomplete
                        v-model="formData.business_id"
                        @keyup.enter="save()"
                        label="Impact Buyer"
                        :items="entities"
                        item-text="name"
                        item-value="id"
                        hide-details
                        @change="updateEntityData"
                        ref="leadFromAutoComplete"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Buyer Type"
                        hide-details
                        readonly
                        v-model="formData.impactBuyerType"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Name"
                        hide-details
                        v-model="formData.leadFromName"
                        @click:append="copyField(formData.leadFromName)"
                        append-icon="mdi-content-copy"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Phone"
                        hide-details
                        v-model="formData.leadFromPhone"
                        @click:append="copyField(formData.leadFromPhone)"
                        append-icon="mdi-content-copy"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 class="px-1 mb-1">
                      <v-text-field
                        label="Email"
                        v-model="formData.leadFromEmail"
                        @click:append="copyField(formData.leadFromEmail)"
                        append-icon="mdi-content-copy"
                        hide-details
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 class="mt-2 mb-0">
                      <div
                        style="
                          width: 100%;
                          text-align: center;
                          font-weight: bold;
                          background: #white;
                          border-radius: 5px;
                          color: white;
                        "
                        class="pa-2"
                      >
                        <span
                          style="font-size: 18pt; float: left; color: #58595b"
                          >Total Enq:
                          <span style="color: #325181">
                            {{ formData.leadFrom_enquiryTotal }}
                          </span>
                        </span>
                        <span style="font-size: 18pt; color: #58595b">
                          Total Rev:

                          <span style="color: #325181">{{
                            formatMoney(formData.leadFrom_revenueTotal)
                          }}</span>
                        </span>

                        <span
                          style="float: right; font-size: 18pt; color: #58595b"
                        >
                          Total $UC:
                          <span style="color: #325181">{{
                            formatMoney(formData.leadFrom_cCTotal)
                          }}</span>
                        </span>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- Enquiry Details Section -->
            <v-flex v-if="keepSupplierData" class="mb-4" xs12>
              <v-card class="ma-2" elevation="5" style="height: 100%">
                <v-toolbar
                  color="#4cc7e8"
                  style="font-weight: bold"
                  dense
                  dark
                  class="mb-0"
                >
                  Lead For ($)
                  <v-spacer></v-spacer>
                  <v-btn icon @click="showLocked = !showLocked">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                  <v-btn icon @click="keepSupplierData = !keepSupplierData">
                    <v-icon v-if="keepSupplierData">mdi-arrow-down</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text v-if="showLocked">
                  <v-layout row wrap>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-autocomplete
                        label="Supplier Name"
                        v-model="formData.leadFor_business_id"
                        @keyup.enter="save()"
                        :items="suppliers"
                        item-text="name"
                        item-value="id"
                        hide-details
                        @change="updateSupplierData"
                        ref="leadForAutoComplete"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Supplier Type"
                        v-model="formData.listTitle"
                        readonly
                        hide-details
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Web Link (URL Keyword)"
                        v-model="formData.urlKeyword"
                        readonly
                        @click:append="
                          copyField(
                            'https://upstreamnz.co.nz/use/' +
                              formData.urlKeyword
                          )
                        "
                        append-icon="mdi-content-copy"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Tracking #"
                        v-model="formData.callRailPhone"
                        readonly
                        hide-details
                        append-icon="mdi-content-copy"
                        @click:append="copyField(formData.callRailPhone)"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 class="px-1 mb-1">
                      <v-text-field
                        label="Opportunity Summary"
                        v-model="formData.leadSummary"
                        hide-details
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 class="mt-2 mb-0">
                      <div
                        style="
                          width: 100%;
                          text-align: center;
                          font-weight: bold;
                          background: #white;
                          border-radius: 5px;
                          color: white;
                        "
                        class="pa-2"
                      >
                        <span
                          style="font-size: 18pt; float: left; color: #58595b"
                          >Total Enq:
                          <span style="color: #4cc7e8">{{
                            formData.leadFor_enquiryTotal
                          }}</span>
                        </span>
                        <span style="font-size: 18pt; color: #58595b">
                          Total Rev:

                          <span style="color: #4cc7e8">
                            {{ formatMoney(formData.leadFor_revenueTotal) }}
                          </span>
                        </span>

                        <span
                          style="float: right; font-size: 18pt; color: #58595b"
                        >
                          Total $UC:
                          <span style="color: #4cc7e8">{{
                            formatMoney(formData.leadFor_cCTotal)
                          }}</span>
                        </span>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              style="color: #58595b"
              xs12
              class="px-0 mx-0"
              v-if="keepSupplierData"
            >
              <lead-from-grid
                :leadFor_business_id="formData.leadFor_business_id"
                :lockedData="formData"
              />
            </v-flex>
            <v-flex style="color: #58595b" xs12 class="px-0 mx-0" v-else>
              <lead-for-grid
                :business_id="formData.business_id"
                :lockedData="formData"
              />
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";

import moment from "moment";
import leadForGrid from "@/components/adminComponents/leadGridComponents/leadForGrid";
import leadFromGrid from "@/components/adminComponents/leadGridComponents/leadFromGrid";

export default {
  props: ["formOpen", "submitedFormData"],
  components: {
    leadForGrid,
    leadFromGrid,
  },
  data: () => ({
    saving: false,
    deleting: false,

    // Lead Specifics
    leadStatusList: [
      "Card Created",
      "Action Taken",
      "Sounding Positive",
      "Sale",
      "Future Follow Up",
      "No Opportunity",
    ],
    leadTypeList: ["Direct", "Their Client", "Out Sourcing", "Collaborative"],
    clipboardTextData: "",
    created: [],
    formData: {},

    keepSupplierData: false,
    showLocked: true,
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      entities: "impactBusinesses/forLeads",
      suppliers: "business/listOrderedByNameSalesEnquiry",
      staff: "user/staff",
    }),
  },
  mounted() {},
  watch: {
    submitedFormData: function() {
      if (this.submitedFormData.hasOwnProperty("business_id")) {
        this.formData = JSON.parse(JSON.stringify(this.submitedFormData));
      }
    },
  },
  methods: {
    updateEntityData() {
      if (
        this.formData.hasOwnProperty("business_id") &&
        this.formData.business_id != ""
      ) {
        let entity = JSON.parse(
          JSON.stringify(
            this.entities.find((e) => e.id == this.formData.business_id)
          )
        );
        this.formData.leadFromType = entity.type;
        this.formData.leadFromName = entity.impactLeadConnectionName;
        this.formData.leadFromPhone = entity.impactPhone;
        this.formData.leadFromEmail = entity.impactEmail;
        this.formData.impactBuyerType = entity.impactBuyerType;
        this.formData.leadFrom_enquiryTotal = entity.enquiryTotal;
        this.formData.leadFrom_revenueTotal = entity.revenueTotal;
        this.formData.leadFrom_cCTotal = entity.cCTotal;
      }
    },
    updateSupplierData() {
      if (
        this.formData.hasOwnProperty("leadFor_business_id") &&
        this.formData.leadFor_business_id != ""
      ) {
        let supplier = JSON.parse(
          JSON.stringify(
            this.suppliers.find(
              (s) => s.id == this.formData.leadFor_business_id
            )
          )
        );
        this.formData.callRailPhone = supplier.callRailPhone;
        this.formData.urlKeyword = supplier.urlKeyword;
        this.formData.listTitle = supplier.listTitle;
        this.formData.leadFor_enquiryTotal = supplier.enquiryTotal;
        this.formData.leadFor_revenueTotal = supplier.revenueTotal;
        this.formData.leadFor_cCTotal = supplier.cCTotal;
        this.formData.opportunitySummary = supplier.specificBenefits;
      }
    },
    copyField(data) {
      var copyText = document.querySelector("#clipboardText");
      copyText.value = data;
      copyText.select();
      setTimeout(() => {
        document.execCommand("copy");
        Vue.notify({
          type: "info",
          duration: 2000,
          title: "Copied to Clipboard",
        });
      }, 100);
    },
    supplierName(id) {
      let supplier = JSON.parse(
        JSON.stringify(this.suppliers.find((s) => s.id == id))
      );
      return supplier.name;
    },
    impactBuyerName(id) {
      let impactBuyer = JSON.parse(
        JSON.stringify(this.entities.find((s) => s.id == id))
      );
      return impactBuyer.name;
    },
    formatMoney(amount) {
      if (typeof amount != "undefined" && amount != "") {
        let formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });
        return formatter.format(parseInt(amount));
      } else {
        return "$0.00";
      }
    },
  },
  filters: {
    moment: function(date) {
      return moment
        .utc(date)
        .local()
        .format("MMM Do YYYY, h:mm a");
    },
  },
};
</script>

<style lang="css">
.centerCheckbox.v-input.v-input--selection-controls.v-input--checkbox.v-input--hide-details.theme--light {
  width: 25px;
  margin: auto;
}
</style>
